module.exports = __webpack_public_path__ + "static/img/particle.5c88c1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/particles/images/particle.png
// module id = kkM+
// module chunks = 0